
@switch (model?.data && model?.type) {
  @case ('page') {
    <page-view
    [model]="modelAsPage"></page-view>
  }
  @case ('category') {
    <category-view
    [model]="modelAsCategory"></category-view>
  }
  @case ('product') {
    <product-view
      [model]="modelAsProduct"
    cy-ppContainer></product-view>
  }
  @default {
    <error-404></error-404>
  }
}
